import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { CurrencySelectorModal } from '@root/widgets/currency-selector/ui/CurrencySelectorModal'

import { TransferCardCurrencyButton } from './transfer-card-currency-button'
import { TransferWalletInfo } from './transfer-wallet-info'

import type { TransferFlowReatom } from '../../../atoms/transfer-flow'
import type { WalletModel } from '@root/entities/wallet/atoms'

type TransferCardProps = {
  wallet: WalletModel
  model: TransferFlowReatom
}

export const TransferCardTop: React.FC<TransferCardProps> = ({
  wallet,
  model,
}) => {
  const { t } = useTranslation()
  const [currencyModalOpen, setCurrencyModalOpen] = useState(false)
  const [currency] = useAtom(model.currency.currencyAtom)
  const [balance] = useAtom(model.amount.balanceAtom)

  const setCurrency = useAction(model.currency.setCurrencyAction)

  return (
    <Root>
      <TransferWalletInfo
        balance={balance}
        currency={currency}
        wallet={wallet}
      />
      <TransferCardCurrencyButton
        currency={currency}
        onClick={() => {
          setCurrencyModalOpen(true)
        }}
      />

      <CurrencySelectorModal
        wallet={wallet}
        title={t('currency.select-currency')}
        open={currencyModalOpen}
        onOpenChange={setCurrencyModalOpen}
        onCurrencySelect={(currency) => {
          setCurrency(currency)
          setCurrencyModalOpen(false)
        }}
        sets={['wallet']}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
`
